import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { WarehouseService } from 'src/app/assabil-sales/services/warehouse-service';
import { WarehouseInventory } from 'src/app/assabil-sales/models/entities/warehouse-inventory';


@Component({
  selector: 'warehouse-inventory-list',
  templateUrl: './warehouse-inventory-list.component.html',
  styleUrls: ['./warehouse-inventory-list.component.scss']
})

export class WarehouseInventoryListComponent extends BasePage2<WarehouseInventory> {

  warehouseInventorys : WarehouseInventory[] = [];
  startDate           : Date;
  endDate             : Date;
  

  constructor(   
    protected toastr                : ToastrService,
    protected router                : Router,
    protected warehouseService      : WarehouseService,
    protected baseService           : BaseService,
    protected leanUtilsService      : LeanUtilsService,
    protected location              : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = "warehouseInventory";
  }



//----------------------------------------------------------------------
getRows(): WarehouseInventory[] {
      return this.warehouseInventorys;
  }
//----------------------------------------------------------------------



//----------------------------------------------------------------------
new(){
    this.warehouseService.warehouseInventoryInitiate().then(result => {
      this.selectedRow = result;
  })
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
  loadData() {    
    this.warehouseService.warehouseInventorysGet(this.startDate, this.endDate).then(result => {
        this.warehouseInventorys = result;
    })
  }
// ---------------------------------------------------
  
//----------------------------------------------------------------------
selectRow(warehouseInventory : WarehouseInventory){
  this.warehouseService.warehouseInventoryGet(warehouseInventory.warehouseInventoryCode).then(result => {
      this.selectedRow = result;
  })
}
//----------------------------------------------------------------------

}
